
import { Component, Vue } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";

// Types
import { Pref, PrefTypesEnum } from "@/store/settings/types";
import { Region, UserPermissions, VueBootstrapField } from "@/store/types";

// Icon
import SureViewIcon from "@/components/SureViewIcon.vue";

// Modals
import RegionEditModal from "@/components/settings/regions/RegionEditModal.vue";
import RegionDeleteModal from "@/components/settings/regions/RegionDeleteModal.vue";

// Third Party
import VuePerfectScrollbar from "vue-perfect-scrollbar";

// Namespaces
const Regions = namespace("regions");
const SettingsStore = namespace("settings");

export const regionTemplate: Region = {
    regionId: 0,
    url: "",
    title: "",
    regionUserId: 0,
    connected: false,
    friendlyName: "",
    active: false
};

@Component({
    components: {
        "sureview-icon": SureViewIcon,
        "vue-perfect-scrollbar": VuePerfectScrollbar,
        "region-edit-modal": RegionEditModal,
        "region-delete-modal": RegionDeleteModal
    }
})

export default class RegionSettings extends Vue {
    
    // Actions
    @SettingsStore.Action loadAllPrefs: () => Promise<void>;
    @Regions.Action loadAllRegions: () => Promise<void>;

    // Getters
    @Getter("getPermissions") private permissions: UserPermissions;
    @SettingsStore.Getter("getAllPrefs") allPrefs: Pref[];
    @Regions.Getter("getAllRegions") regions: Region[];

    // Region Variables
    private regionsTableLoading: boolean = true;
    private regionDefault: Region = { ...regionTemplate };
    private selectedRegion: Region = { ...regionTemplate };

    // Modals
    private showEditModal: boolean = false;
    private showDeleteModal: boolean = false;

    // Table search value
    private filterSearch: string = "";

    // Table's fields
    private fields: VueBootstrapField[] = [
        { key: "title", label: "Title", sortable: true },
        { key: "friendlyName", label: "Friendly Name", sortable: true },
        { key: "url", label: "URL", sortable: true },
        { key: "active", label: "Active", sortable: true },
        { key: "actions", label: "Actions", sortable: false }
    ];

    /**
     * Loads the preferences and regions if user has permissions and preference set
     */
    public async mounted() {
        await this.loadAllPrefs();

        if (this.canSetupRegions) {
            await this.loadAllRegions();
        }

        this.regionsTableLoading = false;
    }

    /**
     * Can only setup regions if preference type 205 is set to be on
     */
    private get canSetupRegions(): boolean {
        var setupRegionsPref = this.allPrefs?.filter(pref => pref.prefTypeID == PrefTypesEnum.AllowRegionalDataserviceCommunication);

        // Return true if user is an admin and preference is set and has a true value
        if (this.permissions.isAdmin && (setupRegionsPref && setupRegionsPref.length > 0 && setupRegionsPref[0].value.toLowerCase().trim() == "true")) {
            return true;
        }

        return false;
    }

    /**
     * Sets the selected region and displays the edit modal
     */
    private editRegion(region: Region): void {
        this.selectedRegion = region;
        this.showEditModal = !this.showEditModal;
    }

    /**
     * Sets the selected region and displays the delete modal
     */
    private removeRegion(region: Region): void {
        this.selectedRegion = region;
        this.showDeleteModal = !this.showDeleteModal;
    }
}
